export const transformToEnumFormat = (inputString: string) => {
  const upperCaseString = inputString.toUpperCase();
  const formattedString = upperCaseString.replace(/ /g, "_");

  return formattedString;
};
